import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

/**
 * The loaded client list plus the clients added from the wizard that the list
 * does not have yet. Once the refetched list has a client, its own entry wins.
 */
export const mergeUserOptions = (
  loadedUsers: ISelectFieldModel[] | undefined,
  createdUsers: ISelectFieldModel[]
): ISelectFieldModel[] => {
  const loaded = loadedUsers ?? [];
  const missing = createdUsers.filter(
    (created) => !loaded.some((user) => user.id === created.id)
  );

  return missing.length > 0 ? [...loaded, ...missing] : loaded;
};
